import React, { Component } from 'react';
import { Redirect} from 'react-router-dom';
import rpc, { rpcWithParams }  from './our/rpc';

export class ContratationBannerRedirect extends Component {
    componentDidMount(){
        this.props.onChangeOffer(6);
         const value = {
            dateOcurrence: new Date(),
            pageVisited: 'Llega por la parte de Contratation banner.',
            idOffert: 6
        };
        rpc({
            type: 'SaveContrationStepsHistory',
            value
        }).then((result) => {
            this.props.onChangeContratationStep(result);
            console.log(result);
        });
    }

    render() {
        return (
            <Redirect to="/Contratation" />

        )
    }
}

export default ContratationBannerRedirect
